import { Variants } from "framer-motion";
import { ANIMATION_STATE, SKINNER_BOX_CONFIG, SKINNER_BOX_STATE } from "./constants";

export const circleVariants: Variants = {
  [ANIMATION_STATE.IDLE]: { rotate: 0 },
  [ANIMATION_STATE.ANIMATING]: {
    rotate: 360,
    transition: { duration: 10, repeat: Infinity, ease: "linear" },
  },
};

export const containerVariants: Variants = {
  [SKINNER_BOX_STATE.IDLE]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.REVEAL]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.CLAIMABLE]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.CLAIMED]: {
    opacity: [1, 0],
    scale: [1, 0],
    transition: {
      duration: SKINNER_BOX_CONFIG.LEAVE_ANIM_DURATION_MS / 1000,
      ease: "easeInOut",
      delay: SKINNER_BOX_CONFIG.LEAVE_ANIM_DELAY_MS / 1000,
    },
  },
};
